import { Button } from "@material-ui/core";
import React from "react";
import SimpleArtist from "../../../../../../../common/types/artist/simple-artist";
import { useHistory } from "react-router";

interface ArtistOwnerProps {
  artist: SimpleArtist;
}

export const ArtistOwnerButton: React.FC<ArtistOwnerProps> = ({ artist }) => {
  const history = useHistory();

  return (
    <React.Fragment>
      <Button
        style={{ marginTop: "10px" }}
        variant="contained"
        onClick={() => history.push(`/users/${artist.ownerId}`)}
      >
        User
      </Button>
    </React.Fragment>
  );
};
